import { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "react-bootstrap";
import { ConsultaPadrao } from "../../../../../components/ConsultaPadrao";
import { model_exercicio_categoria } from "../../../../../models";

export const ExercicioCategoria = forwardRef((props: any, ref) => {
    const [show, setShow] = useState(false);
    const [exercicio, setExercicio] = useState<any>();

    function openModal(_exercicio: any) {
        setExercicio(_exercicio);
        setShow(true);
    }

    function closeModal() {
        setShow(false);
    }

    useImperativeHandle(ref, () => ({
        openModal
    }))

    const columns = [
        { field: 'categoria.catdescricao', header: 'Categoria' },
        { field: 'functions', style: { minWidth: '3rem', width: '3rem' } }
    ];

    return (
        exercicio &&
        <Modal show={show} onHide={closeModal} centered={true} size='xl'>
            <ConsultaPadrao
                disableEdit
                model={{
                    ...model_exercicio_categoria,
                    api_get: '/exercicio/categorias?exercid=' + exercicio?.exercid,
                    inputs: model_exercicio_categoria.inputs.map(input =>
                        input.id === 'exercicio.exercid' ? { ...input, defaultValue: exercicio?.exercid } : input
                    )
                }}
                columns={columns}
                scrollHeight='500px'
            />
        </Modal>
    )
})